function _extends(){return _extends=Object.assign?Object.assign.bind():function(n){for(var e=1;e<arguments.length;e++){var t=arguments[e];for(var r in t)({}).hasOwnProperty.call(t,r)&&(n[r]=t[r])}return n},_extends.apply(null,arguments)}import _styled from"@emotion/styled";import*as React from"react";import{Sider}from"@wp/src/components/common/layout";import{Menu,MenuItem,SubMenu}from"@wp/src/components/common";import{Drawer}from"@wp/src/components/common/drawer";import Badge from"@wp/src/components/common/badge";import{Caption400Neutral500}from"@wp/src/components/common/atoms";export const StyledSidebarHeaderContainer=_styled.div({"flexShrink":"0"});export const StyledSidebarContainer=_styled(Sider)`
  ${{"left":"0px","height":"100%","overflow":"auto","paddingTop":"0.5rem"}}
  ${({theme})=>theme.isProApp?{"--tw-bg-opacity":"1","backgroundColor":"rgb(255 255 255 / var(--tw-bg-opacity))"}:{"--tw-bg-opacity":"1","backgroundColor":"rgb(255 255 255 / var(--tw-bg-opacity))"}}

  .ant-layout-sider-children {
    ${{"display":"flex","height":"100%","flexDirection":"column","flexWrap":"nowrap"}}
  }
`;export const StyledSidebarMenuContainer=_styled.div({"flex":"1 1 0%","overflow":"auto"});export const StyledSidebarFooterContainer=_styled.div({"flexShrink":"0"});export const StyledSidebarFooterContent=_styled.div`
  width: ${props=>props.width};
`;export const StyledSidebarMenu=_styled(Menu)`
  ${{"height":"100%","overflowY":"auto","overflowX":"hidden","backgroundColor":"inherit","paddingLeft":"4px","paddingRight":"4px","paddingTop":"0.25rem","paddingBottom":"0.25rem"}}

  .ant-menu-item {
    ${{"margin":"0px","paddingLeft":"1rem !important","paddingRight":"1rem !important","--tw-text-opacity":"1","color":"rgb(86 85 89 / var(--tw-text-opacity))"}}
    ${({compact})=>compact?{"height":"2rem"}:{"height":"2.5rem"}}

    &:hover {
      ${{"borderRadius":"0.5rem","--tw-bg-opacity":"1","backgroundColor":"rgb(229 231 235 / var(--tw-bg-opacity))","--tw-text-opacity":"1","color":"rgb(86 85 89 / var(--tw-text-opacity))"}}
      &:after {
        ${{"borderStyle":"none"}}
      }
    }

    &.ant-menu-item-selected {
      ${{"borderRadius":"0.5rem","--tw-bg-opacity":"1","backgroundColor":"rgb(229 231 235 / var(--tw-bg-opacity))","--tw-text-opacity":"1","color":"rgb(86 85 89 / var(--tw-text-opacity))"}}
      &:after {
        ${{"borderStyle":"none"}}
      }
    }
  }

  .ant-menu-submenu-selected {
    color: ${props=>props.color};
  }

  .ant-menu-submenu {
    ${{"margin":"0px"}}

    .ant-menu-submenu-title {
      ${{"fontWeight":"400","--tw-text-opacity":"1","color":"rgb(86 85 89 / var(--tw-text-opacity))"}}
    }

    .ant-menu-sub.ant-menu-inline {
      ${{"backgroundColor":"inherit"}}
    }
  }

  .ant-menu-item,
  .ant-menu-submenu {
    &,
    .ant-menu-submenu-title {
      ${{"margin":"0px"}}
    }
    ${{"width":"100%"}}

    .ant-menu-item,
    .ant-menu-submenu-title {
      ${({compact})=>compact?{"height":"2rem"}:{"height":"2.5rem"}}
    }
  }

  .ant-menu-title-content,
  .ant-menu-submenu {
    &,
    .ant-space-item {
      ${{"fontSize":"0.875rem","lineHeight":"1.25rem","fontWeight":"400"}}
    }
  }
`;export const StyledSidebarMenuItem=_styled(MenuItem)``;export const StyledSidebarSubMenu=_styled(SubMenu)`
  .ant-menu-submenu-title {
    ${{"width":"100%","paddingLeft":"1rem !important","paddingRight":"1rem !important"}}
  }

  .ant-menu-item {
    ${{"paddingLeft":"2rem !important"}}
  }
`;export const StyledSettingsTab=_styled.div({"marginTop":"1rem","marginBottom":"1rem","cursor":"pointer","paddingLeft":"1rem","paddingRight":"1rem","fontSize":"1rem","lineHeight":"1.25rem","fontWeight":"400","--tw-text-opacity":"1","color":"rgb(86 85 89 / var(--tw-text-opacity))",":hover":{"--tw-text-opacity":"1","color":"hsl(var(--nextui-primary) / var(--nextui-primary-opacity, var(--tw-text-opacity)))"}});export const StyledAppSidebarDrawer=_styled(Drawer)`
  .ant-drawer-body {
    ${{"padding":"0px !important"}}
  }

  .ant-drawer-content {
    ${{"backgroundColor":"transparent"}}
  }

  .ant-drawer-close {
    ${{"fontSize":"1.875rem","lineHeight":"2.25rem","fontWeight":"700","--tw-text-opacity":"1","color":"rgb(255 255 255 / var(--tw-text-opacity))"}}
  }

  .ant-drawer-content-wrapper {
    width: ${props=>props.width} !important;
  }
`;export const PremiumFeaturesCaption=_styled(Caption400Neutral500)`
  ${{"whiteSpace":"nowrap","paddingLeft":"0.5rem","paddingRight":"0.5rem","paddingTop":"0.5rem","paddingBottom":"0.5rem"}}
`;export const SidebarMenuBadge=props=>React.createElement(Badge,_extends({color:"danger"},props,{classNames:{...props.classNames,base:`px-1 ${props.classNames?.base||""}`}}),props.children);